export const visitReasonService = {
    get
};

function get(params){
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return fetch(`${process.env.REACT_APP_API_URL}visit_reasons`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        }).catch(function(error) {
            console.log('There has been a problem with your fetch operation: ',
            error.message);
        });;
}

function handleResponse(response) {

    if(!response.ok){
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            // window.location.reload(true);
        }
        var error = (response && response.message) || response.statusText;
        if(error.length === 0){
            error = 'Internal Server Error'
        }
        return Promise.reject(error);
    }

    return response.json();
}